export class GblReferenceModel {
  ReferenceId: number;
  ReferenceType: string;
  ReferenceTitle: string;
  ReferenceUID: string;
  Remarks: string;
  IsActive: boolean;
  IsDeleted: boolean;
  DisplaSl: number;
  OrgId: number;
  CreatedBy?: number;
  CreatedOn?: Date;
  LastModifiedBy?: number;
  LastModifiedOn?: Date;
  IsDefault?: boolean;
  DefaultValue: string;
}
